__turbopack_context__.v({
  "brand-background-fill": "icons-module-scss-module__htfhga__brand-background-fill",
  "brand-color-fill": "icons-module-scss-module__htfhga__brand-color-fill",
});
